// i18n helpers: read translated display fields for game data structures.
// Levels/objects/slots/relics/grimoire/pedagogical are keyed by id/key,
// with all display strings stored in /i18n/locales/*.json (namespaces game / relics / grimoire_content / pedagogical / eras).

/**
 * Return a level object with its user-facing strings replaced by localized values.
 * The raw `level` (from data/levels.js) keeps ids/rules; only display fields are translated.
 */
export function localizeLevel(level, t) {
  if (!level) return level;
  const id = level.id;
  const clone = JSON.parse(JSON.stringify(level));
  clone.title = t(`game.level_${id}_title`);
  clone.subtitle = t(`game.level_${id}_subtitle`);
  clone.hint_discovery = t(`game.level_${id}_hint_discovery`);
  clone.hint_engineer = t(`game.level_${id}_hint_engineer`);

  for (const eraKey of Object.keys(clone.eras || {})) {
    const era = clone.eras[eraKey];
    for (const obj of era.objects || []) {
      obj.label = t(`game.level_${id}_obj_${obj.id}`);
    }
    for (const slot of era.slots || []) {
      slot.label = t(`game.level_${id}_slot_${slot.id}`);
      if (slot.renders) {
        const renders = {};
        for (const [state] of Object.entries(slot.renders)) {
          renders[state] = t(`game.level_${id}_slot_${slot.id}_${state}`);
        }
        slot.renders = renders;
      }
    }
  }
  return clone;
}

export function localizeEraLabel(eraKey, t) {
  return t(`eras.${eraKey}`);
}

export function localizeRelic(relicId, relicData, t) {
  return {
    ...relicData,
    name: t(`relics.${relicId}_name`),
    description: t(`relics.${relicId}_desc`),
  };
}

export function localizeGrimoirePage(page, t) {
  if (!page) return page;
  const id = page.id;
  const panels = page.panels.map((_, i) => t(`grimoire_content.page_${id}_panel_${i + 1}`));
  return { ...page, title: t(`grimoire_content.page_${id}_title`), panels };
}

export function localizePedagogical(levelId, card, t) {
  if (!card) return card;
  return {
    ...card,
    field: t(`pedagogical.${levelId}_field`),
    title: t(`pedagogical.${levelId}_title`),
    child_text: t(`pedagogical.${levelId}_child_text`),
    teen_text: t(`pedagogical.${levelId}_teen_text`),
    fun_fact: t(`pedagogical.${levelId}_fun_fact`),
  };
}
